import React, { useEffect, useRef, useState } from 'react';
import './textarea.css';

interface TextareaProps {
  label: string;
  name: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  name,
  value,
  disabled,
  onChange,
}) => {
  const [focused, setFocused] = useState(false);
  const ref = useRef<HTMLTextAreaElement>(null);
  const isActive = focused || Number(value?.trim()?.length) > 0;

  useEffect(() => {
    if (ref.current) {
      ref.current.style.height = 'auto';
      ref.current.style.height = ref.current.scrollHeight + 'px';
    }
  }, [value]);


  return (
    <div className={`floating-textarea ${isActive ? 'active' : ''}`}>
      <label htmlFor={name}>{label}</label>
      <textarea
        id={name}
        name={name}
        value={value}
        ref={ref}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        rows={1}
        style={{ overflow: 'hidden', resize: 'none' }}
        disabled={disabled}
      />
    </div>
  );
};
